import { Container, Row, Col } from "react-bootstrap";
import logo from '../assets/img/whiskey_rebel_logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/nav-icon4.svg'; // GitHub icon
import { trackEvent } from '../lib/analytics';
import { openCookiePreferences } from '../lib/consent';

export const Footer = () => {
    const handleSocialClick = (platform, location) => {
        trackEvent('social_click', {
            category: 'social_media',
            label: `${platform}_footer`,
            custom_location: location
        });
    };

    const handleCookiePreferencesClick = (e) => {
        e.preventDefault();
        openCookiePreferences();
    };

    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col sm={6}>
                        <img className="footer-logo" src={logo} alt="Whiskey Rebel Creative Logo" />
                    </Col>
                    <Col sm={6} className="text-center text-sm-end">
                        <div className="social-icon">
                            <a 
                                href="https://www.linkedin.com/in/george-hoffmann" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="LinkedIn"
                                onClick={() => handleSocialClick('linkedin', 'footer')}
                            >
                                <img src={navIcon1} alt="" />
                            </a>
                            <a 
                                href="https://x.com/whiskeyrebelcre" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="X"
                                onClick={() => handleSocialClick('twitter', 'footer')}
                            >
                                <img src={navIcon2} alt="" />
                            </a>
                            <a 
                                href="https://www.instagram.com/whiskeyrebelcreative" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="Instagram"
                                onClick={() => handleSocialClick('instagram', 'footer')}
                            >
                                <img src={navIcon3} alt="" />
                            </a>
                            <a 
                                href="https://github.com/WhiskeyRebel" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="GitHub"
                                onClick={() => handleSocialClick('github', 'footer')}
                            >
                                <img src={navIcon4} alt="" />
                            </a>
                        </div>
                        <p>&copy; 2026 Whiskey Rebel Creative. All Rights Reserved.</p>
                        <p className="footer-legal-links">
                            <a href="/privacy.html">Privacy &amp; Cookie Policy</a>
                            <span aria-hidden="true"> · </span>
                            <button
                                type="button"
                                className="footer-link-button"
                                onClick={handleCookiePreferencesClick}
                            >
                                Cookie Preferences
                            </button>
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}